import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import getBreachDeferredStatus from '../../../helpers/subscription/getBreachDeferredStatus';
import { isAnnually } from '../../../helpers/flex-helpers/flexBillingFrequency';
import { getAvailableOffers } from '../../../reducers/offers';
import { getBreachBillingDatePrice } from '../../../helpers';
import { products } from '../../../constants';

import DeferredBreachStepper from '../../BreachStepper/DeferredBreachStepper';
import {
  DeferredContainer,
  DeferredCopy,
  DeferredTitle,
  StepperTitle,
  DeferredStepperContainer,
  Break,
} from './breachProductPanels.styles';

const DeferredPanel = ({ currentSubscription }) => {
  const billing = useSelector(state => state?.billing);
  const { productMovingTo } = getBreachDeferredStatus(currentSubscription, billing);

  const offers = useSelector(state => state.offers);
  const subscriptions = useSelector(state => state.subscriptions);
  const availableOffers = getAvailableOffers(offers, subscriptions);
  const currentOffer = availableOffers.find(o => o.family === currentSubscription?.breachDefermentInfo?.family);
  const selection = { offerId: currentOffer.id };

  const { deferredProductPrice: offerPrice, deferredProductBillDate } =
    getBreachBillingDatePrice(currentSubscription, availableOffers, selection) || {};
  const entitlements = useSelector(
    state => state.entitlementsApi?.queries?.['getEntitlements(undefined)']?.data ?? null
  );
  const productsData = useSelector(
    state => state.entitlementsApi?.queries?.['getAllProducts(undefined)']?.data ?? null
  );
  const isFlexUser = useSelector(
    state => state.entitlementsApi?.queries?.['getIsFlexUser(undefined)']?.data?.isFlex === true
  );
  const defermentInfo = entitlements?.defermentInfo ?? currentSubscription?.breachDefermentInfo;
  const isAnnualFlexDeferment = isFlexUser && isAnnually(defermentInfo?.termFrequency);
  const deferredPlan = isAnnualFlexDeferment
    ? (productsData?.eligiblePlans ?? []).find(plan => plan?.planCode === defermentInfo?.defermentPlanCode)
    : null;
  const deferredProductPrice =
    isAnnualFlexDeferment && typeof deferredPlan?.price === 'number' ? deferredPlan.price : offerPrice;

  const deferredProductTitle =
    productMovingTo === products.identity
      ? { light: 'Identity ', bold: 'Plus', suffix: isAnnualFlexDeferment ? ' Annual' : '' }
      : { light: 'Credit', bold: 'Expert', suffix: '' };

  return (
    <DeferredContainer>
      <DeferredCopy>You’re moving to</DeferredCopy>
      <DeferredTitle>
        {deferredProductTitle.light}
        <b>{deferredProductTitle.bold}</b>
        {deferredProductTitle.suffix}
      </DeferredTitle>
      <Break />
      <StepperTitle>What happens now</StepperTitle>
      <DeferredStepperContainer>
        <DeferredBreachStepper
          billingEndDate={billing.endDate}
          deferredFreeTrialEligibility={currentSubscription?.breachDefermentInfo?.descriptors}
          deferredProductPrice={deferredProductPrice}
          deferredProduct={productMovingTo}
          deferredProductBillDate={deferredProductBillDate}
          isAnnual={isAnnualFlexDeferment}
          isFlexUser={isFlexUser}
        />
      </DeferredStepperContainer>
    </DeferredContainer>
  );
};

DeferredPanel.propTypes = {
  currentSubscription: PropTypes.shape({
    breachDefermentInfo: PropTypes.shape({
      family: PropTypes.string,
      descriptors: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
};

export default DeferredPanel;
